//requirement to refresh price based on swatch
console.log('🔵 rbx-custom.js loaded - Event Delegation Version');

// ============================================
// USE EVENT DELEGATION - LISTENERS NEVER LOST
// ============================================

// Attach ONE listener to document that works for ALL swatches (current and future)
document.addEventListener('click', function(e) {
  // Find if click was on or near a color swatch
  const swatchSelectors = [
    '.color-swatch',
    '.swatch__button',
    '.variant-swatch',
    '[data-swatch]',
    'label[for*="color"]',
    'label[for*="Color"]'
  ];
  
  let swatch = null;
  for (const selector of swatchSelectors) {
    swatch = e.target.closest(selector);
    if (swatch) {
      console.log('🟢 SWATCH CLICKED:', selector);
      break;
    }
  }
  
  if (!swatch) return; // Not a swatch click
  
  // Find the product card
  const cardSelectors = [
    '.product-card',
    '.ProductItem',
    '.grid-product',
    '.product-item',
    '[data-product-id]'
  ];
  
  let productCard = null;
  for (const selector of cardSelectors) {
    productCard = swatch.closest(selector);
    if (productCard) {
      console.log('🟢 Found product card:', selector);
      break;
    }
  }
  
  if (!productCard) {
    console.log('⚠️ No product card found');
    return;
  }
  
  // Find the image
  const imgTag = productCard.querySelector('img');
  if (!imgTag) {
    console.log('⚠️ No image found in product card');
    return;
  }
  
  // Store original image if not stored
  if (!productCard.dataset.originalImage) {
    productCard.dataset.originalImage = imgTag.getAttribute("src");
  }
  
  // Get the swatch image URL
  function getSwatchImageUrl(element) {
    // Method 1: Background image from style attribute
    const style = element.getAttribute('style') || '';
    const bgMatch = style.match(/url\(['"']?([^'"')]+)['"']?\)/);
    if (bgMatch) {
      let url = bgMatch[1].replace(/width=\d+/gi, "").replace(/height=\d+/gi, "");
      console.log('  🔵 Found BG image:', url);
      return url;
    }
    
    // Method 2: Background image from computed style
    const computedBg = getComputedStyle(element).backgroundImage;
    if (computedBg && computedBg !== 'none') {
      let url = computedBg.slice(4, -1).replace(/["']/g, "");
      url = url.replace(/width=\d+/gi, "").replace(/height=\d+/gi, "");
      console.log('  🔵 Found computed BG:', url);
      return url;
    }
    
    // Method 3: img tag inside swatch
    const img = element.querySelector('img');
    if (img && img.src) {
      console.log('  🔵 Found img src:', img.src);
      return img.src;
    }
    
    // Method 4: data attributes
    const dataUrl = element.dataset.image || element.dataset.src || element.dataset.variantImage;
    if (dataUrl) {
      console.log('  🔵 Found data attribute:', dataUrl);
      return dataUrl;
    }
    
    console.log('  ⚠️ No image URL found');
    return null;
  }
  
  const newImageUrl = getSwatchImageUrl(swatch);
  
  if (newImageUrl) {
    // Save as selected image
    productCard.dataset.selectedImage = newImageUrl;
    
    // Update the image
    imgTag.setAttribute("src", newImageUrl);
    imgTag.setAttribute("srcset", newImageUrl);
    if (imgTag.dataset.src) imgTag.dataset.src = newImageUrl;
    if (imgTag.dataset.srcset) imgTag.dataset.srcset = newImageUrl;
    
    console.log('✅ Image changed to:', newImageUrl);
  }
  
}, true); // Use capture phase to catch events early


// HOVER effects - use mouseover (bubbles) instead of mouseenter (doesn't bubble)
document.addEventListener('mouseover', function(e) {
  // e.target might be a text node, so check if closest exists
  if (!e.target || !e.target.closest) return;
  
  const swatchSelectors = [
    '.color-swatch',
    '.swatch__button',
    '.variant-swatch',
    '[data-swatch]'
  ];
  
  let swatch = null;
  for (const selector of swatchSelectors) {
    swatch = e.target.closest(selector);
    if (swatch) break;
  }
  
  if (!swatch) return;
  
  // Prevent repeated triggers on same swatch
  if (swatch.dataset.hoverActive === 'true') return;
  swatch.dataset.hoverActive = 'true';
  
  const cardSelectors = [
    '.product-card',
    '.ProductItem',
    '.grid-product',
    '.product-item',
    '[data-product-id]'
  ];
  
  let productCard = null;
  for (const selector of cardSelectors) {
    productCard = swatch.closest(selector);
    if (productCard) break;
  }
  
  if (!productCard) return;
  
  const imgTag = productCard.querySelector('img');
  if (!imgTag) return;
  
  // Store original if not stored
  if (!productCard.dataset.originalImage) {
    productCard.dataset.originalImage = imgTag.getAttribute("src");
  }
  
  function getSwatchImageUrl(element) {
    const style = element.getAttribute('style') || '';
    const bgMatch = style.match(/url\(['"']?([^'"')]+)['"']?\)/);
    if (bgMatch) {
      return bgMatch[1].replace(/width=\d+/gi, "").replace(/height=\d+/gi, "");
    }
    
    const computedBg = getComputedStyle(element).backgroundImage;
    if (computedBg && computedBg !== 'none') {
      return computedBg.slice(4, -1).replace(/["']/g, "").replace(/width=\d+/gi, "").replace(/height=\d+/gi, "");
    }
    
    const img = element.querySelector('img');
    if (img && img.src) return img.src;
    
    return element.dataset.image || element.dataset.src || element.dataset.variantImage || null;
  }
  
  const hoverImageUrl = getSwatchImageUrl(swatch);
  
  if (hoverImageUrl) {
    imgTag.setAttribute("src", hoverImageUrl);
    imgTag.setAttribute("srcset", hoverImageUrl);
    if (imgTag.dataset.src) imgTag.dataset.src = hoverImageUrl;
    if (imgTag.dataset.srcset) imgTag.dataset.srcset = hoverImageUrl;
  }
  
}, true);


// MOUSEOUT - restore to selected or original (use mouseout instead of mouseleave)
document.addEventListener('mouseout', function(e) {
  // e.target might be a text node, so check if closest exists
  if (!e.target || !e.target.closest) return;
  
  const swatchSelectors = [
    '.color-swatch',
    '.swatch__button',
    '.variant-swatch',
    '[data-swatch]'
  ];
  
  let swatch = null;
  for (const selector of swatchSelectors) {
    swatch = e.target.closest(selector);
    if (swatch) break;
  }
  
  if (!swatch) return;
  
  // Reset hover flag
  swatch.dataset.hoverActive = 'false';
  
  const cardSelectors = [
    '.product-card',
    '.ProductItem',
    '.grid-product',
    '.product-item',
    '[data-product-id]'
  ];
  
  let productCard = null;
  for (const selector of cardSelectors) {
    productCard = swatch.closest(selector);
    if (productCard) break;
  }
  
  if (!productCard) return;
  
  const imgTag = productCard.querySelector('img');
  if (!imgTag) return;
  
  // Restore to selected image or original
  const restoreImage = productCard.dataset.selectedImage || productCard.dataset.originalImage;
  
  if (restoreImage) {
    imgTag.setAttribute("src", restoreImage);
    imgTag.setAttribute("srcset", restoreImage);
    if (imgTag.dataset.src) imgTag.dataset.src = restoreImage;
    if (imgTag.dataset.srcset) imgTag.dataset.srcset = restoreImage;
  }
  
}, true);


// ============================================
// PRICE UPDATE FUNCTIONALITY
// ============================================

// Also use event delegation for price updates
document.addEventListener('change', function(e) {
  // Check if it's a color/variant radio button
  if (e.target.type !== 'radio') return;
  
  const input = e.target;
  
  // Find product card
  const cardSelectors = [
    '.product-card',
    '.ProductItem',
    '.grid-product',
    '.product-item',
    '[data-product-id]'
  ];
  
  let productCard = null;
  for (const selector of cardSelectors) {
    productCard = input.closest(selector);
    if (productCard) break;
  }
  
  if (!productCard) return;
  
  const priceElement = productCard.querySelector('sale-price, .price, .product-price');
  const productHandle = productCard.getAttribute('handle') || 
                        productCard.dataset.handle || 
                        productCard.dataset.productHandle;
  
  if (!priceElement || !productHandle) return;
  
  console.log('🔵 Variant changed, updating price...');
  updateRollPrice(input.value, priceElement, productHandle, input.dataset);
  
}, true);


function updateRollPrice(colorOptionValue, priceElement, productHandle, swatchData) {
  console.log('Updating price for:', productHandle);
  
  if (!priceElement || !productHandle) {
    console.error('Missing required elements:', { priceElement, productHandle });
    return;
  }
  
  fetch(`/products/${productHandle}.js`)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(product => {
      console.log('Product data received:', product);
      
      if (!product.variants || product.variants.length === 0) {
        console.error('No variants found');
        return;
      }
      
      const selectedVariantId = parseInt(swatchData.variantId);
      const selectedVariant = product.variants.find(v => v.id === selectedVariantId);
      
      if (!selectedVariant) {
        console.error('Could not find selected variant');
        return;
      }
      
      const selectedColor = selectedVariant.option1;
      
      const rollVariant = product.variants.find(variant => {
        const isMatchingColor = variant.option1 === selectedColor;
        const isRoll = variant.option2 === 'Purchase by Roll';
        return isMatchingColor && isRoll;
      });
      
      console.log('Found roll variant:', rollVariant);
      
      if (rollVariant && priceElement) {
        try {
          const currency = window.Shopify?.currency?.active || 
                           window.theme?.moneyFormat?.replace(/[^A-Z]/g, '') || 
                           'CAD';
          
          const locale = currency === 'CAD' ? 'en-CA' : 
                        currency === 'EUR' ? 'en-EU' : 
                        'en-US';
          
          const formattedPrice = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
          }).format(rollVariant.price / 100);
          
          priceElement.innerHTML = `<span class="sr-only">Sale price</span>${formattedPrice}/ROLL`;
          console.log('✅ Price updated to:', formattedPrice);
        } catch (error) {
          console.error('Error formatting price:', error);
        }
      }
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });
}


// ============================================
// PRODUCT PAGE SWATCH FUNCTIONALITY
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  function isProductPage() {
    return (
      document.body.classList.contains('template-product') ||
      document.querySelector('.product-form') ||
      document.querySelector('.product-gallery') ||
      document.querySelector('[data-section-type="product"]') ||
      window.location.pathname.includes('/products/')
    );
  }
  
  if (!isProductPage()) {
    console.log('Not a product page');
    return;
  }
  
  console.log('🔵 Product page detected, setting up gallery switcher');
  
  function getImageFilename(imageUrl) {
    if (!imageUrl) return '';
    const cleanUrl = imageUrl.split('?')[0];
    const filename = cleanUrl.split('/').pop();
    return filename.replace(/_\d+x\d+|_grande|_large|_medium|_small|_compact|_thumb|_icon|_pico/g, '');
  }
  
  function findMatchingGalleryImage(swatchImageSrc) {
    const swatchFilename = getImageFilename(swatchImageSrc);
    if (!swatchFilename) return null;
    
    const gallerySelectors = [
      '.product-gallery__thumbnail img',
      '.product-gallery__media img',
      '.product-media__thumbnail img',
      '.flickity-slider img',
      '.product-gallery img[data-media-id]'
    ];
    
    let galleryImages = [];
    for (const selector of gallerySelectors) {
      galleryImages = document.querySelectorAll(selector);
      if (galleryImages.length > 0) break;
    }
    
    for (const img of galleryImages) {
      const galleryFilename = getImageFilename(img.src || img.dataset.src);
      if (galleryFilename === swatchFilename) {
        return img;
      }
    }
    return null;
  }
  
  function clickGalleryImage(galleryImg) {
    if (!galleryImg) return false;
    
    galleryImg.click();
    
    const clickableParents = [
      galleryImg.closest('button'),
      galleryImg.closest('.product-gallery__thumbnail'),
      galleryImg.closest('.product-gallery__media'),
      galleryImg.closest('.product-media__thumbnail'),
      galleryImg.closest('[data-media-id]'),
      galleryImg.closest('a')
    ];
    
    for (const parent of clickableParents) {
      if (parent) {
        parent.click();
        return true;
      }
    }
    return false;
  }
  
  // Use event delegation for product page swatches too
  document.addEventListener('click', function(e) {
    const swatchSelectors = [
      '.swatch__button',
      '.color-swatch',
      '.variant-swatch',
      '.product-form__swatch',
      '[data-swatch]'
    ];
    
    let swatch = null;
    for (const selector of swatchSelectors) {
      swatch = e.target.closest(selector);
      if (swatch) break;
    }
    
    if (!swatch) return;
    
    // Get swatch image
    let swatchImageSrc = '';
    const img = swatch.querySelector('img');
    if (img) {
      swatchImageSrc = img.src || img.dataset.src;
    } else if (swatch.tagName === 'IMG') {
      swatchImageSrc = swatch.src || swatch.dataset.src;
    } else {
      const bgImage = getComputedStyle(swatch).backgroundImage;
      if (bgImage && bgImage !== 'none') {
        swatchImageSrc = bgImage.slice(4, -1).replace(/"/g, "");
      }
    }
    
    if (swatchImageSrc) {
      const matchingGalleryImg = findMatchingGalleryImage(swatchImageSrc);
      if (matchingGalleryImg) {
        console.log('🟢 Switching gallery image');
        setTimeout(() => {
          clickGalleryImage(matchingGalleryImg);
        }, 100);
      }
    }
  }, true);
  
  console.log('✅ Product page swatch switcher initialized');
});

console.log('✅ Event delegation setup complete - swatches will work after filtering!');